import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { BlacklistProvider, useBlacklistStore } from '../store';

const BlacklistForm = ({ bulk }) => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit }, collections: { items } } = useBlacklistStore()
  const { handleSuccess, handleError } = useAppAlert()

  const blacklist = JSON.stringify(item) === '{}' ? null : item;

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleClickSidebarClose = useCallback(() => {
    history.push('/settings/blacklist')
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      handleClickSidebarClose()
      const message = payload.id ? 'edited' : 'created';
      handleSuccess('Success', bulk ? 'Blacklist imported.' : `Blacklist ${message}.`)
    } catch {
      handleError('Error', `Blacklist was not saved.`)
    }
  }, [handleSubmit, handleClickSidebarClose, bulk, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClickSidebarClose() }}
      title={bulk ? 'Add multiples entries' : item.id ? 'Edit Item' : 'Add Item'}
    >
      <Helmet title="User Blacklist" />
      <Form data={blacklist} handleSubmit={handleSubmitAndClose} blacklists={items} bulk={bulk} />
    </DefaultSheet>
  </>
}

export default function BlacklistFormLayout({ bulk }) {
  return <BlacklistProvider>
    <BlacklistForm bulk={bulk} />
  </BlacklistProvider>
}
